<mat-card class="grid-card" id="page-content">
    <!-- <mat-card-title>{{'COMPLAINT_SUBTYPE' | translate}}</mat-card-title> -->
    <mat-card-content class="grid-card-content">
        <mat-grid-list cols="4" rowHeight="100px">
            <mat-grid-tile colspan="2">
                <mat-form-field appearance="outline">
                    <mat-label> {{'SEARCH' | translate}} </mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Search" #filter>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="1">
            </mat-grid-tile>
            <mat-grid-tile colspan="1">
                <button mat-button class="btn-primary" color="primary" (click)=add()>
                    <mat-icon>add_circle</mat-icon>
                    Add New Type
                </button>
            </mat-grid-tile>
        </mat-grid-list>
        <!-- <div class="mat-elevation-z8"> -->
            <div class="table-responsive table-container">
            <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc">
                <ng-container matColumnDef="sr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'Sr.no' | translate}} </th>
                    <td mat-cell *matCellDef="let row; let i=index">{{i+1}} </td>
                </ng-container>
                <ng-container matColumnDef="complaintParentCategoryId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'COMPLAINT_TYPE' | translate}} </th>
                    <td mat-cell *matCellDef="let row"> {{row.complaintParentCategoryId |
                        complaintCategoryPipe:categoryList}} </td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'COMPLAINT_SUBTYPE' | translate}} </th>
                    <td mat-cell *matCellDef="let row"> {{row.name}} </td>
                </ng-container>
                <ng-container matColumnDef="legalFramework">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LEGAL_FRAMEWORK' | translate}} </th>
                    <td mat-cell *matCellDef="let row"> {{row.legalFramework}} </td>
                </ng-container>
                <ng-container matColumnDef="complaintResolutionPeriod">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'DAYS_REQUIRED' | translate}} </th>
                    <td mat-cell *matCellDef="let row"> {{row.complaintResolutionPeriod}} </td>
                </ng-container>

                <ng-container matColumnDef="whatsappNameEnglish">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> WhatsApp Name (EN) </th>
                    <td mat-cell *matCellDef="let row"> {{row.whatsappNameEnglish}} </td>
                </ng-container>
                <ng-container matColumnDef="whatsappNameUrdu">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> WhatsApp Name (UR) </th>
                    <td mat-cell *matCellDef="let row"> {{row.whatsappNameUrdu}} </td>
                </ng-container>

                <ng-container matColumnDef="isPublic">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="narrow-column"> {{'PUBLIC_COMPLAINT' | translate}} </th>
                    <td mat-cell *matCellDef="let row" class="narrow-column">
                        @if (row?.isPublic) {
                            <button mat-icon-button color="primary">
                                <mat-icon>check</mat-icon>
                            </button>
                        } @else {
                            <button mat-icon-button color="warn">
                                <mat-icon>close</mat-icon>
                            </button>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="narrow-column"> {{'ACTION' | translate}} </th>
                    <td mat-cell *matCellDef="let row; let i=index;" style="white-space: nowrap">
                        <button mat-icon-button color="primary" (click)=edit(row,i) title="Edit">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button color="warn" (click)=delete(row,i) title="DROP">
                            <mat-icon>delete_forever</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell mat-cell-left-padding-10" colspan="4">{{'NO_DATA_FOUND' | translate}}
                        "{{filter.value}}"</td>
                </tr>
            </table>
            </div>
            <mat-paginator [pageSizeOptions]="config.pageSizeOptionsList" showFirstLastButtons></mat-paginator>

            <!-- </div> -->
    </mat-card-content>

</mat-card>